<template>
  <div>
    <el-row class="bottom20">
      <el-row class="column-name" justify="start">
        <span>故障背景</span>
      </el-row>
      <el-row ref="failureContext_ctn_node">
        <tinymce-editor ref="failureContext_node" :init="tinyMCEConfig" v-model="form.model.failureContext" :disabled="!editable"></tinymce-editor>
      </el-row>
    </el-row>

    <el-row class="bottom20">
      <el-row class="column-name" justify="start">
        <span>处理过程</span>
      </el-row>
      <el-row ref="handleProcess_ctn_node">
        <tinymce-editor ref="handleProcess_node" :init="tinyMCEConfig" v-model="form.model.handleProcess" :disabled="!editable"></tinymce-editor>
      </el-row>
    </el-row>

    <el-row class="bottom20">
      <el-row class="column-name" justify="start">
        <span>原因分析与定位</span>
      </el-row>
      <el-row ref="causeAnalyze_ctn_node">
        <tinymce-editor ref="causeAnalyze_node" :init="tinyMCEConfig" v-model="form.model.causeAnalyze" :disabled="!editable"></tinymce-editor>
      </el-row>
    </el-row>

    <el-row class="bottom20">
      <el-row class="column-name" justify="start">
        <span>解决措施</span>
      </el-row>
      <el-row ref="measure_ctn_node">
        <tinymce-editor ref="measure_node" :init="tinyMCEConfig" v-model="form.model.measure" :disabled="!editable"></tinymce-editor>
      </el-row>
    </el-row>

    <el-row class="bottom20">
      <el-row class="column-name" justify="start">
        <span>复盘结果</span>
      </el-row>
      <el-row ref="result_ctn_node">
        <tinymce-editor ref="result_node" :init="tinyMCEConfig" v-model="form.model.result" :disabled="!editable"></tinymce-editor>
      </el-row>
    </el-row>
  </div>
</template>

<script>
  import qs from 'qs';
  import { ATTACHMENT_SERVER } from '@/api/server';
  import AttachmentServer from '@/api/attachment';
  import ReviewServer from '@/api/review';

  import 'tinymce/tinymce'
  import 'tinymce/themes/silver'
  import 'tinymce/skins/ui/oxide/skin.css'
  import 'tinymce/plugins/image'// 插入上传图片插件
  import 'tinymce/plugins/table'// 插入表格插件
  import 'tinymce/plugins/lists'// 列表插件
  import 'tinymce/plugins/wordcount'// 字数统计插件
  import 'tinymce/plugins/autoresize'// 自动宽度，高度
  import 'tinymce/plugins/paste'// 自动宽度，高度
  import Editor from '@tinymce/tinymce-vue'

  export default {
    name: "SpecialReport",
    components: {'tinymce-editor': Editor},
    props: {
      operation: {
        type: String
      },
      reviewReportId: {
        type: Number
      },
      attachmentStore: {
        type: String,
        default: 'document' // document, base64
      }
    },
    data() {
      let vm = this;
      return {
        tinyMCEConfig: {
          // skin_url: '/tinymce/skins/ui/oxide/skin.css',
          language_url: '/tinymce/langs/zh_CN.js',// 语言包的路径
          language: 'zh_CN', // 语言
          // width: '595pt',
          // max_width: '595pt',
          // height: 200, // 编辑器高度
          branding: false, // 是否禁用“Powered by TinyMCE”
          menubar: false, // 顶部菜单栏显示
          plugins: 'lists image wordcount autoresize paste',
          toolbar: 'undo redo | fontsizeselect formatselect | bold italic forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | lists image | removeformat',
          fontsize_formats: '10pt 12pt 14pt',
          paste_as_text: true,
          image_caption: false,
          image_description: true,
          image_dimensions: true,
          image_title: true,
          image_prepend_url: `${ATTACHMENT_SERVER}/`,
          images_upload_url: `${ATTACHMENT_SERVER}`,
          images_upload_credentials: true,
          image_uploadtab: true,
          images_upload_handler(blobInfo, success, failure) {
            let src;
            if (vm.attachmentStore === 'base64') {
              src = "data:image/jpeg;base64," + blobInfo.base64();
              success(src);
            } else {
              let MB_1 = 1024 * 1024;
              let file = blobInfo.blob();
              if (file.type !== 'image/jpeg') {
                failure('请上传image/jpeg格式的图片！');
              } else if (file.size > MB_1) {
                failure('请上传1MB以内的图片！');
              } else {
                let params = {
                  ownerTable: 'REVIEWREPORTDL',
                  docType: 'REVIEWREPORTDL',
                  ownerId: vm.reviewReportId,
                  file: file,
                };
                AttachmentServer.attachment.upload(params).then((res) => {
                  console.log(res);
                  // src = `${ATTACHMENT_SERVER}/${res[0].URL}&appId=WEB&token=${window.localStorage.getItem('token')}`;
                  src = `${res[0].URL}&appId=WEB&token=${window.localStorage.getItem('token')}`;
                  success(src);
                }, (error) => {
                  failure('上传附件失败！' + error);
                });
              }
            }
          }
        },
        form: {
          model: {
            reviewReportId: this.reviewReportId,
            failureContext: '',
            handleProcess: '',
            causeAnalyze: '',
            measure: '',
            result: '',
          }
        }
      }
    },
    computed: {
      editable() {
        return this.operation === 'report.edit';
      }
    },
    watch: (() => {
      // 普通watch
      let watch = {
        reviewReportId: {
          immediate: true,
          handler() {
            this.loadReviewReportDetail(this.reviewReportId);
          }
        },
      };
      // 动态watch
      ((watch) => {
        let pre = 'form.model';
        let keys = ['failureContext', 'handleProcess', 'causeAnalyze', 'measure', 'result'];
        keys.forEach((key) => {
          watch[`${pre}.${key}`] = {
            deep: true,
            handler(value, old) {
              if (value !== old) {
                if (this.attachmentStore !== 'base64') {
                  this.$nextTick(() => {
                    setTimeout(() => {
                      this.refreshHtmlToken(this.$refs[`${key}_ctn_node`].$el);
                    }, 100);
                  });
                }
              }
            },
          };
        });
      })(watch);
      return watch;
    })(),
    methods: {
      refreshHtmlToken(element) {
        window.console.log(this.$refs['failureContext_node']);
        let body = element.querySelector('iframe').contentWindow.document.querySelector('body');
        body.querySelectorAll('img').forEach((img) => {
          let src = img.src;
          let start;
          if ((start = src.indexOf('?')) !== -1 && start < src.length - 1) {
            let preUrl = src.substring(0, start);
            let paramsStr = src.substring(start + 1);
            let params = qs.parse(paramsStr);
            let appId = window.localStorage.getItem('appId');
            let token = window.localStorage.getItem('token');
            let update = false;
            if (params['appId'] !== appId) {
              params['appId'] = appId;
              update = true;
            }
            if (params['token'] !== token) {
              params['token'] = token;
              update = true;
            }
            if (update) {
              img.src = preUrl + '?' + qs.stringify(params);
            }
          }
        });
      },
      loadReviewReportDetail(reviewReportId) {
        reviewReportId = reviewReportId || this.reviewReportId;
        this.form.model = {
          reviewReportId: reviewReportId,
          failureContext: '',
          handleProcess: '',
          causeAnalyze: '',
          measure: '',
          result: '',
        };
        if (reviewReportId != null) {
          ReviewServer.reviewReport.getDetail(reviewReportId).then((res) => {
            if (res.data.code === 200) {
              if (res.data.result != null) {
                this.form.model = res.data.result;
              }
            } else {
              this.$message.error(res.data.message);
            }

          })
        }
      },
      saveEdit() {
        ReviewServer.reviewReport.modifyDetail(this.reviewReportId, this.form.model).then((res) => {
          if (res.data.code === 200) {
            this.$message.success('保存成功');
            this.$emit('switch-operation', 'report.show');
          } else {
            this.$message.error(res.data.message);
          }
          this.clear();
        });
      },
      cancelEdit() {
        this.clear();
        this.$emit('switch-operation', 'report.show');
        this.loadReviewReportDetail(this.reviewReportId);
      },
      clear() {
        ['failureContext', 'handleProcess', 'causeAnalyze', 'measure', 'result'].forEach((key) => {
          let ref = this.$refs[`${key}_node`];
          let editor = ref != null ? ref.editor : null;
          if (editor != null && editor.undoManager != null) {
            editor.undoManager.clear();
          }
        });
      }
    },
    mounted() {
      this.loadReviewReportDetail(this.reviewReportId);
    },

  }
</script>

<style scoped>
</style>
